import { LocalStorageItems } from "../constants";

export const setLocalStorageItem = (key: string, value: any): void => {
    try {
        if (typeof window === "undefined") return;
        const stringValue = typeof value === "string" ? value : JSON.stringify(value);
        localStorage.setItem(key, stringValue);
    } catch (error) {
        console.error("Error setting localStorage:", error);
    }
};

export const getLocalStorageItem = (key: string): string | null => {
    try {
        if (typeof window === "undefined") return null;
        return localStorage.getItem(key);
    } catch (error) {
        console.error("Error getting localStorage:", error);
        return null;
    }
};

export const getLocalStorageJSON = <T>(key: string): T | null => {
    try {
        if (typeof window === "undefined") return null;
        const item = localStorage.getItem(key);
        if (!item) return null;
        return JSON.parse(item) as T;
    } catch (error) {
        console.error("Error parsing localStorage JSON:", error);
        return null;
    }
};

export const removeLocalStorageItem = (key: string): void => {
    try {
        if (typeof window === "undefined") return;
        localStorage.removeItem(key);
    } catch (error) {
        console.error("Error removing localStorage:", error);
    }
};


export const clearLocalStorageOnLogot = () => {
    localStorage.removeItem(LocalStorageItems.TOKEN);
};